import { render, staticRenderFns } from "./GetStartedNav.vue?vue&type=template&id=626b46c0&scoped=true&"
import script from "./GetStartedNav.vue?vue&type=script&lang=ts&"
export * from "./GetStartedNav.vue?vue&type=script&lang=ts&"
import style0 from "./GetStartedNav.vue?vue&type=style&index=0&id=626b46c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626b46c0",
  null
  
)

export default component.exports